import { ButtonBase, Menu, styled } from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";
import { ChevronArrowDownIcon } from "components/Icons";

import { Typography } from "components/Typography";
import { useMenu } from "hooks/useMenu";

const MenuItem = styled(MuiMenuItem)(() => ({
  fontSize: "12px",
}));

const Y_AXIS_AMOUNT = "AMOUNT";
const Y_AXIS_COUNT = "COUNT";

export const Y_AXIS_TYPES = {
  [Y_AXIS_AMOUNT]: Y_AXIS_AMOUNT,
  [Y_AXIS_COUNT]: Y_AXIS_COUNT,
};

export const Y_AXIS_OPTIONS = {
  [Y_AXIS_AMOUNT]: "Amount",
  [Y_AXIS_COUNT]: "Count",
};

export const YAxisFilter = ({ yAxisKey, setYAxisKey }) => {
  const { anchorEl, handleClose, handleOpen, open } = useMenu();

  const label = Y_AXIS_OPTIONS[yAxisKey] || "Filter By";

  return (
    <>
      <ButtonBase
        onClick={handleOpen}
        disableRipple
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "8px",
          border: "1px solid #EBEDEF",
          borderRadius: "8px",
          padding: "8px 15px",
          marginBottom: "20px",
        }}
      >
        <Typography variant="notification">{label}</Typography>
        <ChevronArrowDownIcon
          sx={{ color: "#8E95A4", fontSize: "14px", marginLeft: "5px" }}
        />
      </ButtonBase>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {Object.entries(Y_AXIS_OPTIONS).map(([value, label]) => (
          <MenuItem
            key={value}
            onClick={() => {
              setYAxisKey(value);
              handleClose();
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
